import speedReport, { timePoint } from '@/utils/speedReport';
import { isDirect, isBrowser } from '@/utils/env';

// method
export const markDataLoaded = 'speedReport@markDataLoaded';

export const requestType = {
  1: 'preCreated',
  2: 'preRequest',
  3: 'preCache',
  4: 'preRequestTimeOut',
  hippyRequest: 'hippyRequest',
};

export const speedReportMixin = {
  created() {
    speedReport.markPoint('created');
  },
  mounted() {
    speedReport.markPoint('mounted');
    if (isDirect && isBrowser()) { // 直出版本，mounted则首屏可操作
      speedReport.markPoint('pageActive');
    }
  },
  updated() {
    if (timePoint.dataLoaded && !timePoint.pageActive) { // 页面渲染完成且可操作
      speedReport.markPoint('pageActive');
    }
  },
  methods: {
    [markDataLoaded](type) {
      if (!timePoint.dataLoaded) { // 数据加载完成
        speedReport.markPoint('dataLoaded');
        speedReport.setRequestType(requestType[type] || 'other');
      }
    },
  },
};
